import { FeedbackBanner } from "@/core/components/feedback-banner";
import { Button } from "@/core/components/ui/button";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { getErrorMessage } from "@/core/api/errors";

export const DeliveryPollingBanner = ({
  error,
  pollingTimedOut,
  isRefreshing,
  onCheckAgain,
}: {
  error: unknown;
  pollingTimedOut: boolean;
  isRefreshing: boolean;
  onCheckAgain: () => void;
}) => {
  if (!error && !pollingTimedOut) return null;

  return (
    <FeedbackBanner variant={error ? "error" : "warning"}>
      <Stack direction="row" align="center" justify="between" gap="md">
        <Stack gap="xs">
          <Typography variant="bodyW3">
            {error
              ? "Couldn't update the delivery statuses."
              : "Delivery updates are taking longer than expected."}
          </Typography>
          <Typography variant="bodyW2" textColor="secondary">
            {error
              ? getErrorMessage(error)
              : "The latest known statuses are shown below."}
          </Typography>
        </Stack>
        <Button
          size="sm"
          variant="secondary"
          loading={isRefreshing}
          onClick={onCheckAgain}
        >
          Check again
        </Button>
      </Stack>
    </FeedbackBanner>
  );
};
